import { addCustomer, allCustomers, deleteCustomer, updateCustomer } from '@/utils/request'
import vue from '@/main'

const state = {
  customerList: []
}

const mutations = {
  RESET (state) {
    state.customerList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allCustomers().then(response => {
        state.customerList = response.data
        resolve(state.customerList)
      })
    })
  },
  customerById ({ commit, state }, id) {
    for (const team of state.customerList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, customer) {
    return new Promise((resolve) => {
      updateCustomer(customer).then(() => {
        for (const cur of state.customerList) {
          if (cur.id === customer.id) {
            Object.assign(cur, customer)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addCustomer(team).then((response) => {
        state.customerList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, customer) {
    return new Promise((resolve) => {
      deleteCustomer(customer.id).then(() => {
        for (const i in state.customerList) {
          if (state.customerList[i].id === customer.id) {
            state.customerList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
